var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 68,
    viewBox: "0 0 319 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6999 44.5H31.3999V67.8H54.6999V44.5Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 0.199951H0V21.2H23.3H31.4V0.199951H23.3Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0999 0.199951H62.8999L43.0999 21.2H31.3999V44.5L54.6999 21.2H62.8999H86.0999V0.199951Z",
    fill: "#2F32FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2 15.8001H117.6V8.70007H155.2V15.8001H140.6V59.3001H132.1V15.8001H132.2Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9 47.4001C150.9 40.0001 156.2 36.6001 167.7 35.5001L180.4 34.2001C180.2 27.6001 178 24.9001 169.9 24.9001C161.8 24.9001 160.3 27.9001 160.3 33.0001H152.1C152.1 24.7001 155.6 18.2001 169.8 18.2001C184 18.2001 188.7 25.3001 188.7 36.2001V59.2001H184.1L182.4 53.1001C180.5 56.3001 174.9 59.7001 166.5 59.7001C158.1 59.7001 150.8 55.8001 150.8 47.3001L150.9 47.4001ZM168.7 53.2001C176.8 53.2001 180.5 48.9001 180.5 41.9001V40.6001L169 41.9001C162 42.7001 159.6 44.2001 159.6 47.4001C159.6 50.6001 162.8 53.3001 168.7 53.3001V53.2001Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 18.8H200.5L202.5 24.4C205 19.2 209.7 17.8 216.9 18.2V25.6C208.6 24.4 204.5 28.4 204.5 37.9V59.3H196V18.8Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.1 39C219.1 28.2 223.2 18.3 239.3 18.3C255.4 18.3 258.4 29.7001 257.4 42.4001H227.8C228.3 49.4001 231.8 53.4001 239 53.4001C246.2 53.4001 247.9 50.2001 248.6 46.9001H257.5C256.8 53.8001 252 59.9001 239.3 59.9001C226.6 59.9001 219 49.9 219 39H219.1ZM248.8 35.7001V35.5C248.8 30 246.3 24.8 238.6 24.8C230.9 24.8 228.4 29.7 228 35.6H248.8V35.7001Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4 3.40002H272.9V59.3H264.4V3.40002Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 32.9001C317.7 31.0001 317 29.1 316.1 27.3C315.2 25.4 314 23.9 312.5 22.6C311.1 21.3001 309.1 20.2 306.8 19.5C304.5 18.7 301.9 18.3 299 18.3C296.1 18.3 293.4 18.7 291.2 19.5C288.9 20.3 287 21.3001 285.5 22.6C284 23.9 282.8 25.5 281.9 27.3C281 29.1 280.3 31.0001 280 32.9001C279.7 34.8001 279.5 36.8 279.5 39C279.5 41.2 279.7 43.3001 280 45.2001C280.3 47.1001 281 49 281.9 50.8C282.8 52.6 284 54.2 285.5 55.5C286.9 56.8 288.9 57.8 291.2 58.6C293.5 59.4 296.1 59.8 299 59.8C312 59.8 318.6 52.8 318.6 39C318.6 25.2 318.4 34.7001 318.1 32.9001H318ZM308.4 49.2001C307.6 50.5001 306.4 51.5 304.8 52.1C303.2 52.8 301.2 53.2001 298.9 53.2001C296.6 53.2001 294.6 52.8 293.1 52.1C291.6 51.4 290.4 50.4 289.6 49.1C288.8 47.8 288.1 46.3001 287.8 44.7001C287.4 43.1001 287.3 41.2 287.3 39.1C287.3 37 287.5 35.1 287.9 33.5C288.3 31.9 288.9 30.4 289.7 29.1C290.5 27.8001 291.7 26.9001 293.2 26.2001C294.8 25.5001 296.8 25.1 299.1 25.1C301.4 25.1 303.4 25.5001 305 26.2001C306.6 26.9001 307.7 27.9001 308.5 29.2001C309.3 30.5001 310 32 310.3 33.6C310.7 35.2 310.8 37.1001 310.8 39.2001C310.8 41.3001 310.6 43.2001 310.3 44.9001C309.9 46.5001 309.3 48 308.5 49.3L308.4 49.2001Z",
    fill: "#0F172A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.7ee74345.svg";
export { ForwardRef as ReactComponent };